import { StationManagementModule } from './station-management/station-management.module';
import { LinearPlayoutComponent } from './linear-playout/linear-playout.component';
import { NgModule } from '@angular/core';
import {
  ExtraOptions,
  PreloadAllModules,
  RouterModule,
  Routes
} from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { StationManagementComponent } from './station-management/station-management.component';
import { DownloadsComponent } from './downloads/downloads.component';
import { AzureProfileAdminGuard } from './guards/azure-profile-admin.guard';
import { AzureProfileGuard } from './guards/azure-profile.guard';
import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';
import { SearchKeywordsComponent } from './search-keywords/search-keywords.component';
import { SettingsComponent } from './settings/settings.component';
import { AudioSubscriptionsComponent } from './audio-subscriptions/audio-subscriptions.component';
import { NameRouteEnum } from './shared/enum/name-route.enum';

export const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: 'always',

  // preload all modules; optionally we could
  // implement a custom preloading strategy for just some
  // of the modules
  preloadingStrategy: PreloadAllModules
};
// Lazy loaded modules *shouldn't* appear in app.modules.ts
export const routes: Routes = [
  { path: '', redirectTo: '/downloads', pathMatch: 'full' },
  {
    path: NameRouteEnum.Home,
    component: HomeComponent,
    canActivate: [MsalGuard, AzureProfileGuard]
  },
  {
    path: NameRouteEnum.Search,
    component: SearchKeywordsComponent,
    canActivate: [MsalGuard, AzureProfileGuard]
  },
  {
    path: NameRouteEnum.Profile,
    component: ProfileComponent,
    canActivate: [MsalGuard, AzureProfileGuard]
  },
  {
    path:  NameRouteEnum.Settings,
    component: SettingsComponent,
    canActivate: [MsalGuard, AzureProfileGuard, AzureProfileAdminGuard]
  },
  {
    path:  NameRouteEnum.Manage,
    loadChildren: (): Promise<typeof StationManagementModule> =>
      import('./station-management/station-management.module').then(m => m.StationManagementModule),
  },
  {
    path:  NameRouteEnum.Downloads,
    component: DownloadsComponent,
    canActivate: [MsalGuard, AzureProfileGuard]
  },
  {
    path:  NameRouteEnum.Subscriptions,
    component: AudioSubscriptionsComponent,
    canActivate: [MsalGuard, AzureProfileGuard]
  },
  {
    path: NameRouteEnum.AuthCallback,
    component: MsalRedirectComponent,
    canActivate: [MsalGuard]
  },
  {
    path:  NameRouteEnum.LinearPlayout,
    component: LinearPlayoutComponent,
    canActivate: [MsalGuard, AzureProfileGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule],
  providers: [],
  declarations: []
})
export class AppRoutingModule { }
